import { useConfig } from "app/contexts/ConfigContext";

export function useSettingsBreadcrumbs() {
  const config = useConfig();

  return [
    { label: "Settings" },
    {
      tabs: [
        {
          label: "Users",
          id: "settings-users",
          target: "/settings/access-control/users",
          section: "Users & Groups",
        },
        {
          label: "Groups",
          id: "settings-groups",
          target: "/settings/access-control/groups",
          section: "Users & Groups",
        },
        ...(config?.dev_flags.includes("admin-settings")
          ? [
              {
                label: "Access Model",
                target: "/settings/access-model",
                section: "Clouds & Integrations",
              },
            ]
          : []),
        {
          label: "Clouds",
          target: `/settings/clouds`,
          section: "Clouds & Integrations",
        },
        {
          label: "Cost",
          target: `/settings/cost`,
          section: "Clouds & Integrations",
        },
        {
          label: "Integrations",
          target: `/settings/integrations`,
          section: "Clouds & Integrations",
        },
      ],
    },
  ];
}
